<div class="mmc-settings-asset-type-container">
  <div class="mmc-settings-asset-type-add-container">
    <div class="mmc-settings-asset-type-add-container-row">
      <div class="mmc-settings-asset-type-add-container-element">
        <div class="mmc-settings-asset-type-add-container-element-input">
          <input type="text" pInputText [value]="assetTypeName"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            placeholder="Enter an asset type"
            [formControl]="assetTypeValidationTextBoxInputControl"
            [(ngModel)]="assetTypeName"
            tooltip
            [tooltipTitle]="inputErrorMessage"
            [tooltipPosition]="'right'"
            tooltipClass="error"
            [tooltipHorizontalOffset]="8"
            maxlength="70"
            #assetTypeValidationTextBox>
        </div>
        <div class="mmc-settings-asset-type-add-container-element-button">
          <button class="btn-medium-secondary btn-spacer" (click)="onAddAssetType()"
            [disabled]="(!assetTypeValidationTextBoxInputControl?.valid ||  !assetTypeName )">Add
          </button>
        </div>
      </div>

    </div>
  </div>
  <div class="mmc-counter-label"> {{getNonDeletedCount() + ' Asset Types'}}</div>
  @if (!isUiTest) {
    <irb-inventory-grid
      class="mmc-settings-asset-type-grid-ag"
      [style.width]="'100%'"
      [gridHeight]="'240px'"
      [showSideBar]="false"
      [gridOptions]="gridOptions"
      [frameworkComponents]='frameworkComponents'
      [rowData]="data"
      (cellValueChanged)="onCellValueChanged($event)"
    (gridReady)="onGridReady($event)"></irb-inventory-grid>
  }
</div>


